import { render, staticRenderFns } from "./DocExport.vue?vue&type=template&id=23346ff2&scoped=true&lang=pug&"
import script from "./DocExport.vue?vue&type=script&lang=js&"
export * from "./DocExport.vue?vue&type=script&lang=js&"
import style0 from "./DocExport.vue?vue&type=style&index=0&id=23346ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23346ff2",
  null
  
)

export default component.exports